import React from 'react';
import { clsb } from 'js/utils/classNames.util';
import { I18n } from 'js/components/common/I18n';

import style from './WarningMessage.scss';

export const WarningMessage = ({ classNames = {}, className = '', warning }) => (
    <I18n
        tagName={'div'}
        tKey={warning}
        defaultValue={warning}
        className={`${clsb([style, classNames], ['warning'])} ${className}`}
    />
);
